import React from 'react';

const Xls = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <title>xls</title>
      <path
        fill="#217346"
        d="M19.048 0l-0 3.047 11.429 0c0.806 0 1.467 0.627 1.52 1.419l0.003 0.104v22.095c0 0.842-0.682 1.524-1.524 1.524v0l-11.429-0 0 3.81-19.048-3.337v-25.326l19.048-3.337zM30.476 4.571l-11.429-0v2.285l2.286 0v2.286l-2.286-0v1.524h2.286v2.286l-2.286-0v1.524l2.286 0v2.286l-2.286-0.001v1.524l2.286 0v2.286l-2.286-0v1.523l2.286 0.001v2.286l-2.286-0v2.286h11.429v-22.095zM28.19 22.095v2.286h-5.333v-2.286h5.333zM13.608 9.143l-2.659 0.16-1.623 3.81-0.107 0.343-0.076 0.259-0.069 0.251-0.053 0.206c0-0.102-0.023-0.198-0.069-0.29l-0.069-0.267-0.076-0.251-0.084-0.229-1.394-3.619-2.568 0.16 2.735 5.928-3.025 5.928 2.507 0.152 1.684-3.886 0.076-0.267 0.061-0.236 0.053-0.198v-0.16l0.053 0.282 0.053 0.236 0.046 0.183 0.046 0.13 1.752 4.145 2.91 0.183-3.276-6.53 3.17-6.423zM28.19 18.286v2.286h-5.333v-2.286h5.333zM28.19 14.476v2.286h-5.333v-2.286h5.333zM28.19 10.667v2.286h-5.333v-2.286h5.333zM28.19 6.857v2.286h-5.333v-2.286h5.333z"
      ></path>
    </svg>
  );
};

export default Xls;
